import {useCan} from '@/shared/hooks/use-permissions'
import {requirePermission} from '@/modules/auth/permissions'
import {useGetInfiniteSolutionDrugs} from '@/modules/drug-catalog/solutions/api'
import {SolutionsFilters} from '@/modules/drug-catalog/solutions/components'
import {SolutionsTable} from '@/modules/drug-catalog/solutions/components/solutions-table'
import {SolutionsSearchSchema} from '@/modules/drug-catalog/solutions/schemas'
import {ResourcesIndexPageHeader} from '@/shared/components/ui/resources-index-page-header'
import {createFileRoute} from '@tanstack/react-router'
import {ResourcesIndexPageTable} from '@/shared/components/ui/resources-index-page-table'

export const Route = createFileRoute('/configuration/drug-catalog/solutions/')({
  beforeLoad: requirePermission('catalogue.view'),
  component: SolutionsPage,
  validateSearch: SolutionsSearchSchema,
})

const LIMIT = 50

function SolutionsPage() {
  const canManageCatalogue = useCan('catalogue.manage')
  const search = Route.useSearch()
  const [sort] = search.sort

  const infinite = useGetInfiniteSolutionDrugs({
    limit: LIMIT,
    sort: {
      dir: sort?.desc ? 'desc' : 'asc',
      field: sort?.id || 'createdAt',
    },
    filters: {
      status: [],
      categories: search.filters?.categories,
      types: search.filters?.types,
      search: search.filters?.search,
    },
  })

  const {getPageQuery, getSingleQuery, toStartRow, listContextParams} = infinite

  return (
    <>
      <ResourcesIndexPageHeader
        {...(canManageCatalogue ? {addNewTo: '/configuration/drug-catalog/solutions/new'} : {})}
      >
        <SolutionsFilters />
      </ResourcesIndexPageHeader>
      <ResourcesIndexPageTable>
        <SolutionsTable
          virtualizer={{getPageQuery, getSingleQuery, toStartRow, listContextParams}}
          table={{state: {sorting: search.sort}}}
        />
      </ResourcesIndexPageTable>
    </>
  )
}
